import React, { useCallback, useEffect, useState } from 'react';
import { wwwRoot, isCn, userUtil, cRoot } from '@liepin/js-core4c-fe';
import { requireLoginModal } from "@liepin/react-login4c-pc";
import IconApplyRecordSVG from '@liepin/icon-c-fe/svg/siderbar-applyrecord.svg';
import IconFavoriteSVG from '@liepin/icon-c-fe/svg/siderbar-favorite.svg';
import IconTopSVG from '@liepin/icon-c-fe/svg/siderbar-top.svg';
import IconErcodeSVG from '@liepin/icon-c-fe/svg/siderbar-ercode.svg';
// import './index.less';
import styled from './index._less';
import SiderBarItem from '../components/SiderBarItem';
import downloadAppPNGCom from '../images/sider-bar-download-app-com.png';
import downloadAppPNGCn from '../images/sider-bar-download-app-cn.png';
import { ERouterMap } from '../../types';


function SiderBar() {
  const boundary = 300;
  const fixTopBoundary = 64;
  const [showTop, setShowTop] = useState<boolean>(false);
  const [fixTop, setFixTop] = useState<number>(fixTopBoundary);
  const [modalStyle, setModalStyle] = useState({});
  const [isLogin] = useState<boolean>(userUtil.isLogin)


  const handleScroll = useCallback(() => {
    const scrollTop = Math.max(document.documentElement.scrollTop, document.querySelector('body').scrollTop);
    if (scrollTop > boundary) {
      if (!showTop) {
        setShowTop(true);
      }
    } else {
      setShowTop(false);
    }

    const targetDistance = fixTopBoundary;
    if (scrollTop > targetDistance) {
      setFixTop(0);
    } else {
      setFixTop(targetDistance - scrollTop);
    }
  }, [showTop]);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [handleScroll]);

  const handleGoTop = useCallback(() => {
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, []);


  const handleMouseOver = useCallback(() => {
    const el = document.querySelector('#sider-bar-download-app');
    const { top } = el.getBoundingClientRect();
    const { offsetHeight } = el;
    const topDis = top - offsetHeight * 0.5;
    setModalStyle({
      top: topDis,
      right: 80,
      display: 'block'
    })
  }, []);

  const showLoginModal = useCallback(() => {
    requireLoginModal({})
  }, []);

  const handleMouseLeave = useCallback(() => {
    setModalStyle({
      display: 'none'
    })
  }, []);

  const handlClickedApplyList = useCallback(() => {
    if (isLogin) {
      window.open(`${cRoot}${ERouterMap.ApplyList}`, '_blank');
    } else {
      showLoginModal();
    }
  }, [isLogin, showLoginModal]);

  const handlClickedFavoriteJob = useCallback(() => {
    if (isLogin) {
      window.open(`${cRoot}${ERouterMap.FavoriteJob}`, '_blank');
    } else {
      showLoginModal();
    }
  }, [isLogin, showLoginModal]);

  return (
    <>
      <style jsx>{styled}</style>
      <div id="framework-sider-bar-container" style={ { top: fixTop } }>
        <div className="position-box">
          <div onClick={handlClickedApplyList} id="sider-bar-applylist">
            <SiderBarItem icon={<IconApplyRecordSVG/>} title="我的投递" />
          </div>
          <div onClick={handlClickedFavoriteJob} id="sider-bar-favorite">
            <SiderBarItem icon={<IconFavoriteSVG/>} title="我的收藏" />
          </div>
          
          <div
            id="sider-bar-download-app"
            onMouseOver={ handleMouseOver }
            onMouseLeave={ handleMouseLeave }
          >
            <SiderBarItem icon={<IconErcodeSVG/>} title="猎聘APP" />

            <div
              id="fix-sider-bar-download-app-modal"
              style={modalStyle}
            >
              <img src={isCn ? downloadAppPNGCn : downloadAppPNGCom} alt="" />
            </div>
          </div>

          <div className="siderbar-bottom-box">
            {
              showTop && (
                <div onClick={ handleGoTop }>
                  <SiderBarItem icon={<IconTopSVG/>} title="TOP" className="sider-bar-gotop-box" />
                </div>
              )
            }

            <a href={`${wwwRoot}/user/feedback/`} target="_blank" id="framework-sider-bar-feedback" >
              <SiderBarItem icon={null} title="投诉建议" />
            </a>
          </div>
        </div>
      </div>
    </>
  )
}

export default SiderBar
